import { useEffect, useState } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import { Link } from "react-router-dom";
import DeleteFaq from "./DeleteFaq";

const Faqs = () => {
    const { auth } = useAuth();
    const [faqs, setFaqs] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [faqID, setFaqID] = useState(null)

    useEffect(() => {
        const fetch = async () => {
            try {
                const response = await axiosPrivate.get("/faqs", {headers: {Authorization: "Bearer " + auth.accessToken}});
                setFaqs(response.data);
            } catch(err) {
                console.log(err);
            }
        }
        fetch();
    }, [auth.accessToken, axiosPrivate]);

    const deleteFaqs = (evt) => {
        setFaqID(evt.target.id)
    }

    return (
        <div>
            {faqID && <DeleteFaq faqID={faqID} setFaqID={setFaqID} setFaqs={setFaqs} />}
            <div style={{paddingBottom:'2rem'}}>
                <span className="relative flex justify-center">
                    <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-transparent bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-75"></div>
                    <span className="relative z-10 bg-white px-6">Faqs</span>
                </span>
            </div>
            <div>
                <Link to="/add-faq">
                    <strong className="rounded border border-indigo-500 bg-indigo-500 px-3 py-1.5 text-[13px] font-medium text-white">
                        Add Faq
                    </strong>
                </Link>

                <div className="overflow-x-auto" style={{paddingTop:'1.5rem'}}>
                    <table className="min-w-full divide-y-2 divide-gray-200 bg-white text-sm">
                        <thead className="ltr:text-left rtl:text-right">
                            <tr>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Question</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Answer</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Action</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-200">
                            {faqs.map(faq => (
                                <tr className="odd:bg-gray-50" key={faq.id}>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{faq.question}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{faq.answer}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">
                                        <button onClick={deleteFaqs} id={faq.id} type="button">
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default Faqs